export const NOTIFICATION_ROUTES = {
  // Inbox / WhatsApp Chat
  new_message: '/whatsapp-chat',
  message_received: '/whatsapp-chat',
  chat_message: '/whatsapp-chat',
  whatsapp_message: '/whatsapp-chat',
  inbox_message: '/whatsapp-chat',
  crm_activity: '/crm-contacts/overview?contact_id=:contact_id',
  incoming_message: '/whatsapp-chat',
  whatsapp_chat: '/whatsapp-chat',
  chat: '/whatsapp-chat',
  message: '/whatsapp-chat',
  inbox: '/whatsapp-chat',

  // Reminders & Tasks
  import_reminders: '/reminders',
  import_reminder: '/reminders',
  reminders_import: '/reminders',
  reminder_import: '/reminders',
  reminder_import_completed: '/reminders/import/:job_id',
  reminder_import_failed: '/reminders/import/:job_id',
  reminder_import_success: '/reminders/import/:job_id',
  reminder_import_job: '/reminders/import/:job_id',
  reminder_created: '/reminders',
  reminder_updated: '/reminders',
  reminder_assigned: '/reminders',
  reminder_due: '/reminders',
  reminder_completed: '/reminders',
  reminder_deleted: '/reminders',
  reminder: '/reminders',
  reminders: '/reminders',
  task_created:
    '/crm-contacts/overview?contact_id=:contact_id&tab=tasks&task_id=:task_id',
  task_assigned:
    '/crm-contacts/overview?contact_id=:contact_id&tab=tasks&task_id=:task_id',
  task_completed:
    '/crm-contacts/overview?contact_id=:contact_id&tab=tasks&task_id=:task_id',
  task_updated:
    '/crm-contacts/overview?contact_id=:contact_id&tab=tasks&task_id=:task_id',
  task_due:
    '/crm-contacts/overview?contact_id=:contact_id&tab=tasks&task_id=:task_id',
  task: '/crm-contacts/overview?contact_id=:contact_id&tab=tasks&task_id=:task_id',
  tasks: '/reminders',

  // CRM Contacts & Leads
  contact_created: '/crm-contacts/overview?contact_id=:contact_id',
  contact_updated: '/crm-contacts/overview?contact_id=:contact_id',
  contact_assigned: '/crm-contacts/overview?contact_id=:contact_id',
  contact: '/crm-contacts/overview?contact_id=:contact_id',
  contacts: '/crm-contacts',
  lead_created: '/crm-contacts/overview?contact_id=:contact_id',
  lead_updated: '/crm-contacts/overview?contact_id=:contact_id',
  lead_assigned: '/crm-contacts/overview?contact_id=:contact_id',
  lead: '/crm-contacts/overview?contact_id=:contact_id',
  leads: '/crm-contacts',
  client_created: '/crm-contacts/overview?contact_id=:contact_id',
  client_updated: '/crm-contacts/overview?contact_id=:contact_id',
  client: '/crm-contacts/overview?contact_id=:contact_id',
  contact_stage_changed:
    '/crm-pipeline?contact_id=:contact_id&stage_id=:stage_id',
  lead_stage_changed: '/crm-pipeline?contact_id=:contact_id&stage_id=:stage_id',
  contact_import: '/crm-contacts',
  contacts_import: '/crm-contacts',
  import_contacts: '/crm-contacts',
  import_contact: '/crm-contacts',
  lead_import: '/crm-contacts',
  leads_import: '/crm-contacts',
  import_leads: '/crm-contacts',
  import_lead: '/crm-contacts',
  note_created:
    '/crm-contacts/overview?contact_id=:contact_id&tab=notes&note_id=:note_id',
  note_added:
    '/crm-contacts/overview?contact_id=:contact_id&tab=notes&note_id=:note_id',
  note_updated:
    '/crm-contacts/overview?contact_id=:contact_id&tab=notes&note_id=:note_id',
  note: '/crm-contacts/overview?contact_id=:contact_id&tab=notes&note_id=:note_id',
  notes: '/crm-contacts',

  // Appointments & Calendar
  appointment_created: '/calendar?appointment_id=:appointment_id',
  appointment_booked: '/calendar?appointment_id=:appointment_id',
  appointment_updated: '/calendar?appointment_id=:appointment_id',
  appointment_cancelled: '/calendar?appointment_id=:appointment_id',
  appointment_reminder: '/calendar?appointment_id=:appointment_id',
  appointment: '/calendar?appointment_id=:appointment_id',
  appointments: '/calendar',
  booking_created: '/calendar?appointment_id=:appointment_id',
  booking_cancelled: '/calendar?appointment_id=:appointment_id',
  booking: '/calendar?appointment_id=:appointment_id',
  calendar_event: '/calendar?appointment_id=:appointment_id',
  calendar: '/calendar',

  // Campaigns
  campaign_created: '/campaigns/:campaign_id',
  campaign_started: '/campaigns/:campaign_id',
  campaign_completed: '/campaigns/:campaign_id',
  campaign_failed: '/campaigns/:campaign_id',
  campaign_sent: '/campaigns/:campaign_id',
  campaign: '/campaigns/:campaign_id',
  campaigns: '/campaigns',
  bulk_campaign: '/campaigns/:campaign_id',

  // WhatsApp Templates & Flows
  template_created: '/templates',
  template_approved: '/templates',
  template_rejected: '/templates',
  template_updated: '/templates',
  template: '/templates',
  templates: '/templates',
  flow_created: '/whatsapp-flows',
  flow_published: '/whatsapp-flows',
  flow_updated: '/whatsapp-flows',
  flow: '/whatsapp-flows',
  flows: '/whatsapp-flows',
  whatsapp_flow: '/whatsapp-flows',
  whatsapp_flows: '/whatsapp-flows',

  // Employees & Team Members
  employee_created: '/employees',
  employee_invited: '/employees',
  employee_updated: '/employees',
  member_invited: '/employees',
  member_joined: '/employees',
  employee: '/employees',
  employees: '/employees',
  member: '/employees',
  members: '/employees',

  // Integrations
  integration_request: '/integrations',
  integration_connected: '/integrations',
  integration_disconnected: '/integrations',
  integration_unhealthy: '/integrations',
  integration_reconnected: '/integrations',
  integration_connection: '/integrations',
  token_expired: '/integrations',
  authentication_failed: '/integrations',
  permissions_revoked: '/integrations',
  integration_failed: '/integrations',
  integration: '/integrations',
  integrations: '/integrations',
  reconnect_request: '/integrations',

  // Segments
  segment_created: '/crm-segments',
  segment_updated: '/crm-segments',
  segment_push_completed: '/crm-segments',
  segment: '/crm-segments',
  segments: '/crm-segments',

  // Feedback & Settings & Profile
  feedback_received: '/settings/feedback',
  feedback: '/settings/feedback',
  settings: '/settings',
  profile: '/profile',

  // Push deep links. Quotation and order ids are resolved in
  // notificationRouter so each page gets the id format it already expects.
  quotation: '/quotations/:quotation_id',
  quotation_created: '/quotations/:quotation_id',
  quotation_updated: '/quotations/:quotation_id',
  quotation_notification: '/quotations/:quotation_id',
  quotations: '/quotations',
  session: '/whatsapp-chat',
  session_notification: '/whatsapp-chat',
  sessions: '/whatsapp-chat',
  order: '/quotations?tab=orders',
  order_notification: '/quotations?tab=orders',
  orders: '/quotations?tab=orders',
  customer_quotation: '/quotations?tab=orders',
  customer: '/crm-contacts/overview?contact_id=:contact_id',
  customer_notification: '/crm-contacts/overview?contact_id=:contact_id',
  customers: '/crm-contacts',

  // General & System
  system_notification: '/dashboard',
  general_alert: '/dashboard',
  company_updated: '/dashboard',
  dashboard: '/dashboard',
  system: '/dashboard',
  general: '/dashboard',
  info: '/dashboard',
  alert: '/dashboard',
};
